export const AUTH_URL = process.env.REACT_APP_LOGIN_URL;
